import React, { Component } from "react";
import {
  Box,
  Paper,
  Typography,
  Grid,
  TextField,
  Button,
  Divider,
  MenuItem,
} from "@mui/material";
import DownloadIcon from "@mui/icons-material/Download";
import FilterAltIcon from "@mui/icons-material/FilterAlt";
import FormatListNumberedOutlinedIcon from "@mui/icons-material/FormatListNumberedOutlined";
import base from "./base.json";
import { Link, useLocation, useNavigate, useParams } from "react-router-dom";

export class Frenchise_form extends Component {
  constructor(props) {
    super(props);
    this.state = {
      franchise_company_name: "",
      franchise_date: "",
      franchise_applicant_name: "",
      current_job_or_bussiness: "",
      applicant_phone_no: "",
      investment_buget: 0,
      current_income: 0,
      contact_email_id: "",
      frenchise_area_pincode: "",
      frenchise_address: "",
      frenchise_password : "",

      is_switch_case: true,
      is_vendor_delete: false,
    };
    this.handleChange = this.handleChange.bind();
  }

  handleChange = (e) => {
    this.setState({
      [e.target.name]: e.target.value,
    });
  };

 

  handleChangee = (e) => {
    this.setState({
      [e.target.name]: e.target.files[0],
    });
  };

 

  handleChangeee = (e) => {
    this.setState({
      [e.target.name]: e.target.files,
    });
  };



  save = () => {
     if( this.state.franchise_company_name!== "" &&
      this.state.franchise_date!== "" &&
      this.state.franchise_applicant_name!== "" &&
      this.state.current_job_or_bussiness!== "" &&
      this.state.applicant_phone_no!== "" &&
      this.state.investment_buget > 0 &&
      this.state.current_income > 0 &&
      this.state.contact_email_id!== "" &&
      this.state.frenchise_area_pincode!== "" &&
      this.state.frenchise_address!== "" &&
      this.state.frenchise_password !== ""){

    fetch(`${base.base_url}/website/frenchise/addFranchise`, {
      headers: {
        "content-type": "application/json",
      },
      method: "post",
      body: JSON.stringify({
        franchise_company_name: this.state.franchise_company_name,
        franchise_date: this.state.franchise_date,
        franchise_applicant_name: this.state.franchise_applicant_name,
        current_job_or_bussiness: this.state.current_job_or_bussiness,
        applicant_phone_no: this.state.applicant_phone_no,
        investment_buget: this.state.investment_buget,
        current_income: this.state.current_income,
        contact_email_id: this.state.contact_email_id,
        frenchise_area_pincode: this.state.frenchise_area_pincode,
        frenchise_address: this.state.frenchise_address,
        frenchise_password : this.state.frenchise_password
      }),
    })
      .then((res) => {
        return res.json();
      })
      .then((data) => {
        this.setState({
      franchise_company_name: "",
      franchise_date: "",
      franchise_applicant_name: "",
      current_job_or_bussiness: "",
      applicant_phone_no: "",
      investment_buget: 0,
      current_income: 0,
      contact_email_id: "",
      frenchise_area_pincode: "",
      frenchise_address: "",
      frenchise_password  :""
        },()=>{
          alert(data.message)
        })
      });

            }else{
              alert("Fill All Fields")
            }

  };

  render() {
    return (
      <Box sx={{ display: "flex" }}>
        <Box
          sx={{ width: { sm: "100%", xs: "100%" } }}
        >
          <Box sx={{ height: "100%", width: "100%" }}>
            <Box
              sx={{
                height: 47,
                //  width: "100%",
                backgroundColor: "#fff",
                borderRadius: 0,
                mt: 0.2,
                borderBottom: 0.5,
                borderBottomColor: "#dddddd",
                display: "flex",
                flexDirection: "row",
                justifyContent: "space-between",
                alignItems: "center",
              }}
            >
              <Typography sx={{ fontSize: 18, ml: 1 }}>
                Franchise Application Form
              </Typography>

              <Link to="/frenchiseList">
                <Button
                  variant="contained"
                  size="samll"
                  startIcon={
                    <FormatListNumberedOutlinedIcon
                      sx={{ height: 20, width: 20 }}
                    />
                  }
                  disableElevation
                  sx={{
                    height: 25,
                    fontSize: 13,
                    textTransform: "none",
                    backgroundColor: "#288ade",
                    mr: 1,
                  }}
                >
                  Franchise List
                </Button>
              </Link>
            </Box>

            <Box
              sx={{
                pl: { xs: 1, sm: 3 },
                pt: { xs: 1, sm: 3 },
                pr: { xs: 1, sm: 3 },
                display: this.state.is_switch_case ? "block" : "none",
              }}
            >
              <Box>
                <Paper
                  variant="outlined"
                  elevation={1}
                  style={{ minHeight: 150, width: "100%", color: "#fff" }}
                >
                  <Box sx={{ padding: 3 }}>
                    <Typography
                      style={{
                        fontWeight: "bold",
                        color: "#1b7bce",
                        fontSize: 13,
                        marginTop: 3,
                        textTransform: "uppercase",
                        marginBottom: 8,
                        marginLeft: 1,
                      }}
                    >
                      Personal Information (Franchise)
                    </Typography>

                    <Grid container spacing={2}>
                      <Grid item size={{ xs: 12, sm: 6, md: 3 }}>
                        <Typography
                          sx={{
                            fontSize: 11,
                            color: "#515151",
                            fontWeight: "bold",
                            p: 0.5,
                          }}
                        >
                          Frenchise Company Name
                        </Typography>
                        <TextField
                          size="small"
                          fullWidth
                          placeholder="Frenchise Company Name"
                          InputProps={{
                            style: { fontSize: 11, fontWeight: "500" },
                          }}
                          name="franchise_company_name"
                          value={this.state.franchise_company_name}
                          onChange={this.handleChange}
                        />
                      </Grid>

                      <Grid item size={{ xs: 12, sm: 6, md: 3 }}>
                        <Typography
                          sx={{
                            fontSize: 11,
                            color: "#515151",
                            fontWeight: "bold",
                            p: 0.5,
                          }}
                        >
                          Franchise Date
                        </Typography>
                        <TextField
                          size="small"
                          fullWidth
                          type="date"
                          placeholder="Franchise Date"
                          InputProps={{
                            style: { fontSize: 11, fontWeight: "500" },
                          }}
                          name="franchise_date"
                          value={this.state.franchise_date}
                          onChange={this.handleChange}
                        />
                      </Grid>

                      <Grid item size={{ xs: 12, sm: 6, md: 3 }}>
                        <Typography
                          sx={{
                            fontSize: 11,
                            color: "#515151",
                            fontWeight: "bold",
                            p: 0.5,
                          }}
                        >
                          Applicant Name
                        </Typography>
                        <TextField
                          size="small"
                          type="text"
                          placeholder="Applicant Name"
                          fullWidth
                          InputProps={{
                            style: { fontSize: 11, fontWeight: "500" },
                          }}
                          name="franchise_applicant_name"
                          value={this.state.franchise_applicant_name}
                          onChange={this.handleChange}
                        />
                      </Grid>

                      <Grid item size={{ xs: 12, sm: 6, md: 3 }}>
                        <Typography
                          sx={{
                            fontSize: 11,
                            color: "#515151",
                            fontWeight: "bold",
                            p: 0.5,
                          }}
                        >
                          Current Job or Bussiness
                        </Typography>
                        <TextField
                          size="small"
                          type="text"
                          placeholder="Current Job or Bussiness"
                          fullWidth
                          InputProps={{
                            style: { fontSize: 11, fontWeight: "500" },
                          }}
                          name="current_job_or_bussiness"
                          value={this.state.current_job_or_bussiness}
                          onChange={this.handleChange}
                        />
                      </Grid>

                      <Grid item size={{ xs: 12, sm: 6, md: 3 }}>
                        <Typography
                          sx={{
                            fontSize: 11,
                            color: "#515151",
                            fontWeight: "bold",
                            p: 0.5,
                          }}
                        >
                          Applicant Phone No
                        </Typography>
                        <TextField
                          size="small"
                          type="text"
                          placeholder="Applicant Phone No"
                          fullWidth
                          InputProps={{
                            style: { fontSize: 11, fontWeight: "500" },
                          }}
                          name="applicant_phone_no"
                          value={this.state.applicant_phone_no}
                          onChange={this.handleChange}
                        />
                      </Grid>

                      <Grid item size={{ xs: 12, sm: 6, md: 3 }}>
                        <Typography
                          sx={{
                            fontSize: 11,
                            color: "#515151",
                            fontWeight: "bold",
                            p: 0.5,
                          }}
                        >
                          Investment Buget
                        </Typography>
                        <TextField
                          size="small"
                          type="text"
                          placeholder="Investment Buget"
                          fullWidth
                          InputProps={{
                            style: { fontSize: 11, fontWeight: "500" },
                          }}
                          name="investment_buget"
                          value={this.state.investment_buget}
                          onChange={(e)=>this.setState({investment_buget : e.target.value >= 0 ? e.target.value  : 0 })}
                        />
                      </Grid>

                      <Grid item size={{ xs: 12, sm: 6, md: 3 }}>
                        <Typography
                          sx={{
                            fontSize: 11,
                            color: "#515151",
                            fontWeight: "bold",
                            p: 0.5,
                          }}
                        >
                          Currrent Income
                        </Typography>
                        <TextField
                          size="small"
                          type="text"
                          placeholder="Currrent Income"
                          fullWidth
                          InputProps={{
                            style: { fontSize: 11, fontWeight: "500" },
                          }}
                          name="current_income"
                          value={this.state.current_income}
                          onChange={(e)=>this.setState({current_income : e.target.value >= 0 ? e.target.value  : 0 })}
                        />
                      </Grid>

                      <Grid item size={{ xs: 12, sm: 6, md: 3 }}>
                        <Typography
                          sx={{
                            fontSize: 11,
                            color: "#515151",
                            fontWeight: "bold",
                            p: 0.5,
                          }}
                        >
                          Contact Email Id
                        </Typography>
                        <TextField
                          size="small"
                          type="text"
                          placeholder="Contact Email Id"
                          fullWidth
                          InputProps={{
                            style: { fontSize: 11, fontWeight: "500" },
                          }}
                          name="contact_email_id"
                          value={this.state.contact_email_id}
                          onChange={this.handleChange}
                        />
                      </Grid>

                      <Grid item size={{ xs: 12, sm: 6, md: 3 }}>
                        <Typography
                          sx={{
                            fontSize: 11,
                            color: "#515151",
                            fontWeight: "bold",
                            p: 0.5,
                          }}
                        >
                          Frenchise Address
                        </Typography>
                        <TextField
                          size="small"
                          type="text"
                          placeholder="Frenchise Address"
                          fullWidth
                          multiline
                          minRows={3}
                          InputProps={{
                            style: { fontSize: 11, fontWeight: "500" },
                          }}
                          name="frenchise_address"
                          value={this.state.frenchise_address}
                          onChange={this.handleChange}
                        />
                      </Grid>

                      <Grid item size={{ xs: 12, sm: 6, md: 3 }}>
                        <Typography
                          sx={{
                            fontSize: 11,
                            color: "#515151",
                            fontWeight: "bold",
                            p: 0.5,
                          }}
                        >
                          Area Pincode
                        </Typography>
                        <TextField
                          size="small"
                          type="text"
                          placeholder="Pine code"
                          fullWidth
                          InputProps={{
                            style: { fontSize: 11, fontWeight: "500" },
                          }}
                          name="frenchise_area_pincode"
                          value={this.state.frenchise_area_pincode}
                          onChange={this.handleChange}
                        />
                      </Grid>

                      

<Grid item size={{ xs: 12, sm: 6, md: 3 }}>
                        <Typography
                          sx={{
                            fontSize: 11,
                            color: "#515151",
                            fontWeight: "bold",
                            p: 0.5,
                          }}
                        >
                         Password
                        </Typography>
                        <TextField
                          size="small"
                          type="password"
                          placeholder="Pine code"
                          fullWidth
                          InputProps={{
                            style: { fontSize: 11, fontWeight: "500" },
                          }}
                          name="frenchise_password"
                          value={this.state.frenchise_password}
                          onChange={this.handleChange}
                        />
                      </Grid>

                    </Grid>

                    <br />
                    <br />

                    <Box>
                      <Button
                        size="small"
                        variant="contained"
                        sx={{ textTransform: "none", fontSize: 12 }}
                        onClick={this.save}
                      >
                        Apply For Franchise
                      </Button>
                    </Box>
                  </Box>
                </Paper>
              </Box>

              <br />
              <br />
              <br />
            </Box>
          </Box>
        </Box>
      </Box>
    );
  }
}

export default Frenchise_form;

export function Frenchise_formc(props) {
  const navigate = useNavigate();
  const location = useLocation();
  const param = useParams();
  return <Frenchise_form param={param} navigate={navigate}></Frenchise_form>;
}



